<template>
  <div class="main-layout">
    <app-sidebar class="main-layout__sidebar" />
    <app-header class="main-layout__header" />
    <main class="main-layout__content">
      <router-view />
      <!-- <logout-modal /> -->
      <logout-modal-new />
    </main>
  </div>
</template>

<script>
import AppSidebar from '@/components/AppSidebar';
import AppHeader from '@/components/AppHeader';
import LogoutModalNew from '@/components/LogoutModalNew';

import localStorage from '@/helpers/localStorage';

localStorage.initialize();

export default {
  name: 'MainLayout',
  components: {
    AppHeader,
    AppSidebar,
    LogoutModalNew
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    $route(to, from) {
      if (this.$store.getters.loggedIn) {
        this.$store.dispatch('checkToken')
          .then(({ data }) => {
            this.$store.dispatch('restoreUserSessionFromToken', this.$store.state.localToken);
          })
          .catch((e) => { this.$store.dispatch('logout', e); });
      }
    }
  }
};
</script>

<style lang="scss">
.main-layout {
  display: grid;
  grid-template-areas:
    "sidebar header"
    "sidebar content";
  grid-template-columns: 210px 1fr;
  grid-template-rows: 130px 1fr;
  min-height: 100vh;
  background-color: $--app-main-bg-color;

  .main-layout__sidebar {
    grid-area: sidebar;
    background-color: $--app-sidebar-bg-color;
  }

  .main-layout__header {
    grid-area: header;
    background-color: $--app-header-bg-color;
  }

  .main-layout__content {
    grid-area: content;
    background-color: $--app-main-bg-color;
  }
}
</style>
